import type { FC } from 'react';

export const ApplicationConnectivityReportTab: FC = () => (
  <div className='flex-1 bg-default' />
);
